import PillarFormAddressInput from "./PillarFormAddressInput";
import PillarFormButton from "./PillarFormButton";
import PillarFormCheckbox from "./PillarFormCheckbox";
import PillarFormColorInput from "./PillarFormColorInput";
import PillarFormCombobox from "./PillarFormCombobox";
import PillarFormDateTimeInput from "./PillarFormDateTimeInput";
import PillarFormDynamicArray from "./PillarFormDynamicArray";
import PillarFormEmailInput from "./PillarFormEmailInput";
import PillarFormExpirationDateInput from "./PillarFormExpirationDateInput";
import PillarFormFieldTextArray from "./PillarFormFieldTextArray";
import PillarFormHexColorInput from "./PillarFormHexColorInput";
import PillarFormIconPicker from "./PillarFormIconPicker";
import PillarFormInputWrapper from "./PillarFormInputWrapper";
import PillarFormJSONInput from "./PillarFormJSONInput";
import PillarFormLoadingButton from "./PillarFormLoadingButton";
import PillarFormLoadingSubmitButton from "./PillarFormLoadingSubmitButton";
import PillarFormNumberInput from "./PillarFormNumberInput";
import PillarFormPasswordInput from "./PillarFormPasswordInput";
import PillarFormPercentageInput from "./PillarFormPercentageInput";
import PillarFormProductSelect from "./PillarFormProductSelect";
import PillarFormRadio from "./PillarFormRadio";
import PillarFormSelectMenu from "./PillarFormSelectMenu";
import PillarFormSubmitButton from "./PillarFormSubmitButton";
import PillarFormSubmittingModal from "./PillarFormSubmittingModal";
import PillarFormSwitch from "./PillarFormSwitch";
import PillarFormTemplateEditor from "./PillarFormTemplateEditor";
import PillarFormTextAreaInput from "./PillarFormTextAreaInput";
import PillarFormTextInput from "./PillarFormTextInput";
import PillarFormTimeInput from "./PillarFormTimeInput";
import PillarFormUSDInput from "./PillarFormUSDInput";
import PillarSelectComponent from "./PillarSelectComponent";

export const populatePillarFormComponents = (form: any) => {
  form.Checkbox = PillarFormCheckbox;
  form.AddressInput = PillarFormAddressInput;
  form.LoadingButton = PillarFormLoadingButton;
  form.Radio = PillarFormRadio;
  form.TextInput = PillarFormTextInput;
  form.Button = PillarFormButton;
  form.ExpirationDateInput = PillarFormExpirationDateInput;
  form.LoadingSubmitButton = PillarFormLoadingSubmitButton;
  form.SubmittingModal = PillarFormSubmittingModal;
  form.SelectMenu = PillarFormSelectMenu;
  form.TimeInput = PillarFormTimeInput;
  form.FieldTextArray = PillarFormFieldTextArray;
  form.NumberInput = PillarFormNumberInput;
  form.ColorInput = PillarFormColorInput;
  form.PasswordInput = PillarFormPasswordInput;
  form.SubmitButton = PillarFormSubmitButton;
  form.USDInput = PillarFormUSDInput;
  form.Combobox = PillarFormCombobox;
  form.HexColorInput = PillarFormHexColorInput;
  form.PercentageInput = PillarFormPercentageInput;
  form.Switch = PillarFormSwitch;
  form.DateTimeInput = PillarFormDateTimeInput;
  form.IconPicker = PillarFormIconPicker;
  form.DynamicArray = PillarFormDynamicArray;
  form.InputWrapper = PillarFormInputWrapper;
  form.ProductSelect = PillarFormProductSelect;
  form.EmailInput = PillarFormEmailInput;
  form.JSONInput = PillarFormJSONInput;
  form.SelectComponent = PillarSelectComponent;
  form.TextAreaInput = PillarFormTextAreaInput;
  form.TemplateEditor = PillarFormTemplateEditor;
};
